// src/auth/ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth"; // <-- corrected import

/**
 * Wrap any route that requires authentication
 * @param {React.ReactNode} children - Component to render if authenticated
 */
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  // While checking auth, render nothing (or a loader)
  if (loading) return <div>Loading...</div>;

  // If not logged in, redirect to login page
  if (!user) return <Navigate to="/login" replace />;

  // Else render the protected component
  return children;
};

export default ProtectedRoute;